module.exports = __webpack_public_path__ + "8a2a7469df13e4650b5a0a811b40373f.ico";